import React, { useEffect, useState, useContext } from 'react'
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import { intervalToDuration } from 'date-fns'

import { getRaceById } from '@/races';
import { getOrdinal } from '@/utils/getOrdinal'
import { convertAmount } from '@/utils/currencyResolver'
import { AuthContext } from '../contexts/AuthContext';

export default function Race() {
  const { racesData } = useContext(AuthContext)
  const [searchParams] = useSearchParams();
  const raceId = searchParams.get('raceId')
  const [race, setRace] = useState(null)
  useEffect(() => {
    setRace(racesData.find(r => r.id == raceId))
  }, [racesData, raceId])
  useEffect(() => {
    console.log(race)
  }, [race])
  /* 
  * @Todo calculate current user's wagered amount between race.start_date and race.end_date to determine 
  * their current position. race.prize[currentPosition] will determine their current prize.
  */

  return (
    <div>
      {race && (
        <>
          <img className="w-24 mx-auto" src="/race.svg" alt="" />
          <p className="text-base font-medium text-white mt-8 text-center">{race.title}</p>
          <div className="flex justify-center mt-6">
            <ModularCountdown time={new Date(race.endDate.seconds * 1000)} />
          </div>
          <p className="mt-6 text-gray-300 text-center">
            Join DuelArena's Daily 1B 07 race! For every bet placed, you’ll climb above other racers in the top 10 positions increasing your prize the higher you go! For race announcements & bonus prize information, be sure to join our race Telegram channel! <br /> <span className="text-white underline">https://t.me/DuelArenaRaces</span>
          </p>
          <div className="mt-6 grid gap-4">
            <div>
              <label className="block mb-1 font-medium">Your Position</label>
              <input value={getOrdinal(630)} type="text" className="bg-gray-700 border-transparent shadow-md" readOnly />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block mb-1 font-medium">Your Current Prize</label>
                <input value={convertAmount(race?.prizes[630] || 0)} type="text" className="bg-gray-700 border-transparent shadow-md" readOnly />
              </div>
              <div>
                <label className="block mb-1 font-medium">Your Wagered</label>
                <input value={0} type="text" className="bg-gray-700 border-transparent shadow-md" readOnly />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

const ModularCountdown = ({ time }) => {
  const [now, setNow] = useState(new Date)

  useEffect(() => {
    const timer =
      setInterval(() => setNow(new Date), 1000);
    return () => clearInterval(timer);
  }, [now]);

  let duration = intervalToDuration({
    start: new Date(),
    end: time
  })

  return (
    <div className="grid grid-cols-4 gap-4">
      <div className="flex flex-col justify-center items-center">
        <label className="block mb-1 font-medium">Days</label>
        <div className="rounded border-2 border-gray-700 w-12 text-center font-medium py-1 text-white">{duration.days}</div>
      </div>
      <div className="flex flex-col justify-center items-center">
        <label className="block mb-1 font-medium">Hours</label>
        <div className="rounded border-2 border-gray-700 w-12 text-center font-medium py-1 text-white">{duration.hours}</div>
      </div>
      <div className="flex flex-col justify-center items-center">
        <label className="block mb-1 font-medium">Minutes</label>
        <div className="rounded border-2 border-gray-700 w-12 text-center font-medium py-1 text-white">{duration.minutes}</div>
      </div>
      <div className="flex flex-col justify-center items-center">
        <label className="block mb-1 font-medium">Seconds</label>
        <div className="rounded border-2 border-gray-700 w-12 text-center font-medium py-1 text-white">{duration.seconds}</div>
      </div>
    </div>
  )
}